import { render, staticRenderFns } from "./ConfigStandardsList.vue?vue&type=template&id=60d8a34c&scoped=true&"
import script from "./ConfigStandardsList.vue?vue&type=script&lang=js&"
export * from "./ConfigStandardsList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigStandardsList.vue?vue&type=style&index=0&id=60d8a34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d8a34c",
  null
  
)

export default component.exports